var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"mt-3",attrs:{"justify":"center"}},[_c('v-pagination',{attrs:{"value":_vm.params.page,"length":_vm.totalPages,"total-visible":10},on:{"input":_vm.pageChanged}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }